/**
 * Selects which map/geolocation provider a config target (web, android, backend
 * geocoding, AI agent) uses. Default is {@link EMapProvider.GoogleMaps} so existing
 * projects — which have no `mapProvider` field persisted — keep their current
 * Google Maps behavior unchanged.
 *
 * `Amap` (AutoNavi / 高德地图) is the alternative for regions where Google services
 * are unavailable (e.g. mainland China).
 */
export enum EMapProvider {
  GoogleMaps = 0,
  Amap = 1
}
